import { NgModule, InjectionToken } from '@angular/core';

export let CORE_CONFIG = new InjectionToken<CoreConfig>('core.config');

export class CoreConfig {
  mixpanelApiKey: string;
  posthogKey: string;
  posthogHost: string;
}

//TODO: Externalize these configs into it's own file and reference that instead 
export const CORE_DI_CONFIG: CoreConfig = {
  mixpanelApiKey: 'c3494e44caafdad02a542e212bfc6889',
  posthogKey: 'phc_YhhaAGkg2cdhAnxqDk57a5NY53xjskTtT61IUazoq6t',
  posthogHost: 'https://pa.apigateway.co',
};

@NgModule({
  providers: [{
    provide: CORE_CONFIG,
    useValue: CORE_DI_CONFIG
  }]
})

export class CoreConfigModule { }
